export const NEW_LOCATION_CODE_STRING = '新規データ作成…';
